module.exports = __webpack_public_path__ + "static/media/TOTAL-SCORE-5.d4bd2123.png";